export const selectUserList = (state) => state.user;
export const selectUserLoading = (state) => state.user.loading;
export const selectUserError = (state) => state.user.error;